import React, { useEffect } from "react";
import {
  Modal,
  Card,
  Row,
  Spin,
  Button,
} from "../../../../components/common/utils/antd-imports/AntdImports";
import { useSelector, useDispatch } from "react-redux";
import { getOfferComments } from "../../../../store/thunks/seller-thunks/SellerThunk";
import "./OfferCommentsModal.css";

const OfferCommentsModal = ({
  offerCommentsModal,
  setOfferCommentsModal,
  dynamicId,
}) => {
  const dispatch = useDispatch();
  const handleCancel = () => {
    setOfferCommentsModal(false);
  };
  const { isLoading, offer_comments_list } = useSelector(
    (state) => state.sellerCampaigns
  );
  useEffect(() => {
    dispatch(getOfferComments(dynamicId));
  }, [dispatch, dynamicId]);
  return (
    <div>
      <Modal
        open={offerCommentsModal}
        className="offer-comments"
        title="Offer Price Negotiations"
        okText="Send Campaign"
        closable={false}
        onCancel={handleCancel}
        width={"713px"}
        style={{ height: "531px" }}
        footer={
          <Button
            className="comments-close-btn billboard-button-2"
            onClick={handleCancel}
          >
            Close
          </Button>
        }
      >
        {isLoading ? (
          <div className="loading-css">
            <Spin size="large" fullscreen />
          </div>
        ) : (
          <div height={200}>
            {offer_comments_list?.length ? (
              <>
                {offer_comments_list?.map((offer_comment, offerIndex) => {
                  return (
                    <Card className="offer-comment-card" key={offerIndex}>
                      <Row className="product-title">
                        {offer_comment.product_title}
                      </Row>
                      <Row className="product-comments">
                        {offer_comment.product_comments}
                      </Row>
                    </Card>
                  );
                })}
              </>
            ) : (
              <Card className="offer-comment-card">
                <h1>No Offer Comments</h1>
              </Card>
            )}
          </div>
        )}
      </Modal>
    </div>
  );
};

export default OfferCommentsModal;
